import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../video-showcase.css";
import { SHOWCASE } from "./productVideos";

// Homepage strip of product videos. Each card shows its poster until pressed; only one video plays at a time.
export default function VideoShowcase() {
  const [playing, setPlaying] = useState<string | null>(null);
  return (
    <section className="hs-wrap hs-section vs-section" aria-labelledby="home-videos-title">
      <div className="hs-section-heading">
        <div>
          <p className="hs-eyebrow">WATCH IT IN ACTION</p>
          <h2 id="home-videos-title">See our machines and parts at work.</h2>
        </div>
      </div>
      <div className="vs-grid">
        {SHOWCASE.map((video) => (
          <article className="vs-card" key={video.id}>
            <div className="vs-media">
              {playing === video.id ? (
                <video
                  ref={(player) => player?.focus({ preventScroll: true })}
                  tabIndex={0}
                  className="vs-player"
                  src={video.src}
                  poster={video.poster}
                  controls
                  autoPlay
                  playsInline
                  aria-label={video.title}
                />
              ) : (
                <button type="button" className="vs-play" onClick={() => setPlaying(video.id)} aria-label={`Play video: ${video.name}`}>
                  <img src={video.poster} alt="" loading="lazy" width={720} height={900} />
                  <span className="vs-play-icon" aria-hidden="true" />
                </button>
              )}
            </div>
            <h3>{video.name}</h3>
            <p>{video.summary}</p>
            <Link to={video.to}>View details →</Link>
          </article>
        ))}
      </div>
    </section>
  );
}
